/**
 * 控制 css animate 动画模块  （结合animate.scss）
 *
 *
 * 参数：
 *      animate  动画名称
 *      speed   动画时间  默认：400毫秒（参数可省）   可定义值：[200,400,800,1000,1500,2000]
 *      fn      回调函数
 *
 * @author fulh
 * @create 2016-08-23 19:41:55
 */

(function ($) {
  $.extend($.fn, {
    effect: function (animate, speed, fn) {
      function _getPrev() {
        var a = document.body.style;
        return a.animation !== undefined
          ? 'animationend'
          : a.WebkitAnimation !== undefined
          ? '-webkit-'
          : a.webkitAnimation !== undefined
          ? '-webkit-'
          : a.MozAnimation !== undefined
          ? '-moz-'
          : a.OAnimation !== undefined
          ? '-o-'
          : a.msAnimation !== undefined
          ? '-ms-'
          : 'none';
      }

      var time = 0,
        callback = fn;
      var className = [animate];
      if ($.isFunction(speed)) {
        callback = speed;
      }

      if (speed != 0) {
        time = speed || 400;
        className.push('animated');
        className.push('speed-' + time);
      }

      var animationend = {
        '-webkit-': 'webkitAnimationEnd',
        '-moz-': 'animationend',
        '-o-': 'OAnimationEnd',
        '-ms-': 'msAnimationEnd',
        animationend: 'animationend',
        none: '',
      }[_getPrev()];
      if (!animationend.length) {
        callback && callback.apply(this);
      }

      var $this = $(this);
      className = className.join(' ');
      $this.addClass(className).one(animationend, function () {
        $this.removeClass(className);
        callback && callback.apply(this);
      });
      return this;
    },
  });
})(jQuery);
